var React = require('react');
var Modal = require('react-bootstrap').Modal;
var Button = require('react-bootstrap').Button;
var Link = require('react-router').Link;
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var Access = require('./Access');

var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var ContactStore = require('../../stores/ContactStore');
var UserStore = require('../../stores/UserStore');
var Invocation = require('../../api/Invocation');

function getState(props) {
  const client = ClientStore.get()

  return {
    client,
    partners: client ? client.authorisedPartners : [] || [],
    loading: ContactStore.loading() || ClientStore.loading(),
    working: ContactStore._working,
  }
}

var AccessPartner = React.createClass({
  contextTypes: {
    router: React.PropTypes.func
  },
  componentDidMount: function() {
    ClientStore.addChangeListener(this.update);
    ContactStore.addChangeListener(this.update);
    UserStore.addChangeListener(this.update);
  },
  componentWillMount: function () {
    this.update()

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }

    (this.props && this.props.query) && this.loadPartner(this.props.query.partner);
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.query.partner !== this.props.query.partner) {
      this.loadPartner(nextProps.query.partner)
    }
  },
  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
    ContactStore.removeChangeListener(this.update);
    UserStore.removeChangeListener(this.update);
  },
  handleDeauth: function () {
    Invocation.partner.deauthorise(
      this.state.partner.partner.id,
      this.state.client.id
    )
      .then(() => this.context.router.transitionTo('access'))
      .then(() => setTimeout(() => ServiceActions.getServices(), 200))
  },

  loadPartner(hash) {
    console.log('loads');

    if (!hash) {
      this.setState({
        partnerLoading: false,
      })

      return
    }

    this.setState({
      partnerLoading: true,
    })
    Invocation.partner.getPartner(hash)
      .then(res => {
        this.setState({
          partner: res.body.partner,
          partnerLoading: false,
        })
      })
      .catch(() => { this.setState({
        loadError: true,
        partnerLoading: false,
      })})
  },

  alreadyAuthorised(partner) {
    if (!this.state.client) {
      return false
    }

    return this.state.partners.findIndex(ap => ap.partner.id === partner.id) > -1
  },

  submit() {
    this.setState({
      working: true,
    })

    Invocation.partner.authorise(this.state.partner.id, this.state.client.id)
      .then(() => {
        this.setState({
          complete: true,
          working: false,
          submitError: false,
        })

        this.context.router.transitionTo("access")
        setTimeout(() => ServiceActions.getServices(), 200)
      })
      .catch(() => { this.setState({
        submitError: true,
      })})
  },
  update: function () {
    this.setState(getState(this.props))
  },
  getInitialState: function () {
    return {
      errors: null,
      working: null,
    }
  },
  render: function () {
    let modalInsides

    if (this.state.loadError || !this.props.query.partner) {
      modalInsides = (
        <div>
          <div className="modal-header">
            <h4>Authorise Partner Error</h4>
          </div>

          <div className="modal-body">
            <p>
              There has been an error loading. Please check that the URL in your
              browser matches the URL you were sent from your Technical Partner.
            </p>

            <p>
              The URL should look something like: <strong>https://portal.infinite.net.au/auth?partner=bugsbunny</strong>
            </p>
          </div>
        </div>
      )
    } else if (this.state.loading || this.state.partnerLoading || !this.state.partner || !this.state.client) {
      modalInsides = (
        <div>
          <div className="modal-header">
            <h4>Authorise Partner</h4>
          </div>
          <div className="modal-body">
            <Loading/>
          </div>
        </div>
      )
    } else if (this.alreadyAuthorised(this.state.partner)) {
      modalInsides = (
        <div>
          <div className="modal-header">
            <h4>Authorise Partner</h4>
          </div>
          <div className="modal-body">
            <p>You have already authorised {this.state.partner.name} as a partner.</p>
          </div>
        </div>
      )
    } else {
      modalInsides = (
        <div>
          <div className="modal-header">
            <h4>Authorise Partner</h4>
          </div>
          <div className="modal-body">
            <p>
              <em>{this.state.partner.name}</em> has requested that you authorise them for technical access
              to your account to enable them to do diagnostics on your account and
              talk to us about technical issues.
            </p>

            <p>
              By authorising <em>{this.state.partner.name}</em>, you will allow any agent of <em>{this.state.partner.name}</em>{' '}
              to contact us on your behalf. You can revoke this authorisation at any
              time by <Link to="support">contacting us</Link>.
            </p>

            <section className="form-horizontal">
              <div className="form-group">
                <label className="col-md-3 control-label">Authorising</label>
                <div className="col-md-9">
                  <p className="form-control-static">{this.state.partner.name}</p>
                  <span className="help-block">
                    {this.state.partner.url}<br />
                    {this.state.partner.number}
                  </span>
                </div>
              </div>
              <div className="form-group">
                <label className="col-md-3 control-label">To Access</label>
                <div className="col-md-9">
                  <p className="form-control-static">{this.state.client.name}</p>
                  <span className="help-block">
                    To change which Client you will be granting access, select a client
                    on the top right.
                  </span>
                </div>
              </div>
              <div className="form-group">
                <div className="col-md-9 col-md-offset-3">
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" onChange={e => this.setState({
                        agree: e.target.checked,
                      })} />
                      I agree to the Infinite Networks{' '}
                      <span className="text-muted">Standard Terms and Conditions</span> and the{' '}
                      <span className="text-muted">Acceptable Use Policy</span>
                    </label>
                  </div>
                  <span className="help-block">
                    Authorising a Technical Partner to access your account grants that
                    partner full technical access to your account. Check out our T&Cs at{' '}
                    <a href="https://www.infinite.net.au/policies-agreements/">
                      https://www.infinite.net.au/policies-agreements/
                    </a>
                  </span>
                </div>
              </div>
              {this.state.submitError && (
                <div className="form-group has-error">
                  <div className="col-md-9 col-md-offset-3">
                    <span className="help-block">
                      An error occurred while authorising this partner.
                    </span>
                  </div>
                </div>
              )}
            </section>
          </div>
          <div className="modal-footer">
            <ButtonLink to="access">Cancel</ButtonLink>

            <Button
              bsStyle="success"
              type="submit"
              disabled={!this.state.agree || this.state.working || this.state.submitError}
              onClick={this.submit}
            >
              <i className={this.state.working ? 'fa fa-spin fa-circle-o-notch' : 'fa fa-key'} />{' '}
              Authorise
            </Button>
          </div>
        </div>
      )
    }

    return (
      <div>
        <Access />

        <Modal
          animation={false}
          onHide={() => this.context.router.transitionTo('access')}
          show
        >
          {modalInsides}
        </Modal>
      </div>
    );
  }
})
module.exports = AccessPartner;



// WEBPACK FOOTER //
// ./app/components/Access/AccessNewPartner.js